"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const complex_data_1 = require("complex-data");
const ListView_1 = __importDefault(require("@/components/data/ListView"));
const overdue_1 = __importDefault(require("@/pages/index/api/overdue"));
const config_1 = require("@/config/dictionary/config");
class ContractList extends complex_data_1.ComplexList {
}
exports.default = (0, vue_1.defineComponent)({
    name: 'ContractArea',
    components: {
        ListView: ListView_1.default
    },
    props: {
        value: {
            type: String
        }
    },
    data() {
        return {
            mainData: new ContractList({
                name: '诉讼合同',
                prop: 'contractList',
                module: {
                    dictionary: {
                        option: {},
                        propData: {
                            id: 'id'
                        },
                        list: [
                            {
                                prop: 'id',
                                name: 'ID',
                                originProp: 'id',
                                originFrom: 'list',
                                mod: {}
                            },
                            {
                                prop: 'contractNumber',
                                name: '合同号',
                                originFrom: 'list',
                                mod: {
                                    list: {
                                        width: config_1.listWidth.contractNumber,
                                    }
                                }
                            },
                            {
                                prop: 'customerName',
                                name: '承租人',
                                originFrom: 'list',
                                mod: {
                                    list: {
                                        width: config_1.listWidth.personnelName
                                    }
                                }
                            },
                            {
                                prop: 'maxDay',
                                name: '逾期天数',
                                originFrom: 'list',
                                mod: {
                                    list: {
                                        width: config_1.listWidth.getWidth(4)
                                    }
                                }
                            },
                            {
                                prop: 'numb',
                                name: '逾期期数',
                                originProp: 'numb',
                                originFrom: 'list',
                                mod: {
                                    list: {
                                        width: config_1.listWidth.getWidth(4)
                                    }
                                }
                            },
                            {
                                prop: 'overdueRank',
                                name: '逾期级别',
                                originProp: 'overdueRank',
                                originFrom: 'list',
                                mod: {
                                    list: {}
                                }
                            },
                            {
                                prop: 'residueRent',
                                name: '剩余租金',
                                originProp: 'residueRent',
                                originFrom: 'list',
                                mod: {
                                    list: {
                                        width: config_1.listWidth.getWidth(6)
                                    }
                                }
                            },
                            {
                                prop: 'total',
                                name: '逾期总额',
                                originProp: 'total',
                                originFrom: 'list',
                                mod: {
                                    list: {
                                        width: config_1.listWidth.getWidth(6)
                                    }
                                }
                            },
                            {
                                prop: 'rentOver',
                                name: '逾期租金',
                                originProp: 'rentOver',
                                originFrom: 'list',
                                mod: {
                                    list: {
                                        width: config_1.listWidth.getWidth(5)
                                    }
                                }
                            },
                            {
                                prop: 'penaltyOver',
                                name: '逾期罚息',
                                originProp: 'penaltyOver',
                                originFrom: 'list',
                                mod: {
                                    list: {
                                        width: config_1.listWidth.getWidth(5)
                                    }
                                }
                            },
                        ]
                    }
                },
                $getData() {
                    return new Promise((resolve, reject) => {
                        const { value } = this.$getExtra('origin');
                        overdue_1.default.overdueListInfo.require({
                            overdueRecordId: value
                        }).then(res => {
                            this.$list = [res.data.data];
                            resolve({ status: 'success' });
                        }).catch(err => {
                            // eslint-disable-next-line no-console
                            console.error(err);
                            reject(err);
                        });
                    });
                }
            }),
            listOption: {
                table: {
                    optionProps: {
                        bordered: true
                    }
                },
                search: false,
                edit: false
            }
        };
    },
    watch: {
        value(value) {
            if (value) {
                this.loadData();
            }
        },
    },
    mounted() {
        this.mainData.$onLife('loaded', {
            data: () => {
                if (this.mainData.$list[0]) {
                    this.$emit('loaded', this.mainData.$list[0]);
                }
            }
        });
        this.loadData();
    },
    beforeUnmount() {
        this.mainData.$reset();
    },
    methods: {
        loadData() {
            if (this.value) {
                this.mainData.$setExtra('origin', {
                    value: this.value
                });
                this.mainData.$loadData(true);
            }
        }
    }
});
